import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  // 14 minutes and 50 seconds in seconds
  const initialTime = 14 * 60 + 50;
  const [timeLeft, setTimeLeft] = useState(initialTime);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) return initialTime; // Loop back or stop
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };
  return <div className="bg-red-600 text-white text-center py-3 px-4 font-bold text-sm md:text-base sticky top-0 z-50 shadow-md" data-id="element-1">
      <div className="container mx-auto flex justify-center items-center gap-2 animate-pulse" data-id="element-2">
        <span data-id="element-3">
          ⏳ OFERTA EXPIRA EN:{' '}
          <span className="font-mono text-lg" data-id="element-4">{formatTime(timeLeft)}</span>
        </span>
        <span className="hidden md:inline" data-id="element-5">|</span>
        <span data-id="element-6">🔥 CUPOS LIMITADOS HOY</span>
      </div>
    </div>;
}